module.exports = __webpack_public_path__ + "static/media/cobranzas.87c254ed.m4v";